import { styled, Typography } from '@mui/material'
import { ReactNode } from 'react'

export interface DrawerHeaderProps {
  content?: ReactNode
  title?: ReactNode
  subtitle?: ReactNode
  prefix?: ReactNode
  suffix?: ReactNode
}

const DrawerHeaderWrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
})

const DrawerHeaderContent = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 12,
})

const DrawerHeaderText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

export function DrawerDefaultHeader({
  content,
  prefix,
  subtitle,
  suffix,
  title,
}: DrawerHeaderProps) {
  if (!content && !title && !subtitle && !prefix && !suffix) {
    return null
  }

  if (content) {
    return <DrawerHeaderWrapper>{content}</DrawerHeaderWrapper>
  }

  return (
    <DrawerHeaderWrapper>
      <DrawerHeaderContent>
        {prefix}
        <DrawerHeaderText>
          {title && (
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="caption" sx={{ lineHeight: 'normal' }}>
              {subtitle}
            </Typography>
          )}
        </DrawerHeaderText>
      </DrawerHeaderContent>
      {suffix}
    </DrawerHeaderWrapper>
  )
}
